import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ChangePasswordFormDialog from "../common/ChangePasswordFormDialog";
import { accountService } from "../../services/account.service";
import { getApiErrorMessage } from "../../helpers";
import { AUTH_USER_TYPES } from "../../constants/auth.constants";
import useAuth from "../../hooks/useAuth";
import { appActions } from "../../redux/actions";

const ChangeOwnPasswordDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { userType, tenantId, activeTenantId } = useAuth();
  const [loading, setLoading] = useState(false);
  const isTenant = userType === AUTH_USER_TYPES.TENANT;

  const handleSubmit = async (payload) => {
    setLoading(true);
    try {
      if (isTenant) {
        await accountService.changeTenantOwnPassword(
          {
            password: payload?.newPassword || payload,
            oldPassword: payload?.oldPassword || "",
          },
          activeTenantId || tenantId
        );
      } else {
        await accountService.changeSystemOwnPassword({
          password: payload?.newPassword || payload,
        });
      }
      dispatch(appActions.apiSuccessMessage("Password updated successfully."));
      onClose?.();
    } catch (err) {
      throw new Error(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ChangePasswordFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={loading}
      title="Change Password"
      description="Update the password for your signed-in account."
      requireCurrentPassword={isTenant}
    />
  );
};

export default ChangeOwnPasswordDialog;
